import { useEffect, useState } from 'react'

const useDebounce = (value, delay) => {
  const [deBounceValue, setDeBounceValue] = useState(null)

  useEffect(() => {
    const handleTimeClear = setTimeout(() => {
      setDeBounceValue(value)
    }, delay)

    return () => {
      clearTimeout(handleTimeClear)
    }
  }, [value, delay])

  return deBounceValue
}

export default useDebounce
